import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ContentViewComponent from '../../../../Component/ContentViewComponent/ContentViewComponent';
import { getRoutePathname } from '../../../../Handler/RouteHandler';
import { initFormHandler } from '../../../../Handler/FormHandler';
import { Grid2 as Grid } from '@mui/material';
import TextFieldComponent from '../../../../Component/TextFieldComponent/TextFieldComponent';
import ButtonComponent from '../../../../Component/ButtonComponent/ButtonComponent';
import SelectComponent from '../../../../Component/SelectComponent/SelectComponent';
import CheckboxComponent from '../../../../Component/CheckboxComponent/CheckboxComponent';
import ApiHandler from '../../../../Handler/ApiHandler';
import { dispatch } from '../../../../App';
import { SnackbarOpen } from '../../../../Reducer/SnackBarReducer/SnackBarSlice';

const optionsDayOfWeek = [
    { value: 1, label: 'Lundi' },
    { value: 2, label: 'Mardi' },
    { value: 3, label: 'Mercredi' },
    { value: 4, label: 'Jeudi' },
    { value: 5, label: 'Vendredi' },
    { value: 6, label: 'Samedi' },
    { value: 7, label: 'Dimanche' },
];

function Availability() {
    const [loading, setLoading] = React.useState(true);
    const [breadcrumbs, setBreadcrumbs] = React.useState({});
    const [isEdit, setIsEdit] = React.useState(true);
    const [info, setInfo] = React.useState();
    const params = useParams();
    const navigate = useNavigate();

    const [form, setForm] = React.useState({
        dayOfWeek: {
            name: "dayOfWeek",
            label: "Jour",
            textHelper: "Choisissez un jour de semaine.",
            type: "integer",
            defaultValue: "",
            options: { validation: ["required"] },
        },
        startTime: {
            name: "startTime",
            label: "Heure de début",
            textHelper: "Format attendu: HH:mm (ex: 09:00).",
            type: "text",
            defaultValue: "",
            options: {},
        },
        endTime: {
            name: "endTime",
            label: "Heure de fin",
            textHelper: "Format attendu: HH:mm (ex: 18:30).",
            type: "text",
            defaultValue: "",
            options: {},
        },
        isActive: {
            name: "isActive",
            label: "Jour ouvert",
            textHelper: "Décochez pour marquer ce jour comme fermé.",
            type: "boolean",
            defaultValue: true,
            options: {},
        },
    });
    const handlerForm = initFormHandler(form, setForm);
    React.useEffect(() => {
        handlerForm.start();
    }, [handlerForm]);

    React.useEffect(() => {
        setBreadcrumbs({
            title: 'Configuration',
            context: isEdit ? 'Éditer une disponibilité' : 'Ajouter une disponibilité',
            description: '',
            links: [
                { label: "Calendrier des disponibilités", path: getRoutePathname("configuration_availability_list") }
            ]
        });

        setTimeout(() => setLoading(false), 800);
    }, [isEdit]);

    React.useEffect(() => {
        if (params.id === 'add') {
            setIsEdit(false);
        } else {
            ApiHandler.get(
                {
                    route: 'configuration_availability_get',
                    params: { id: params.id },
                },
                (response) => {
                    if (response.status === 200) {
                        handlerForm.setDataApi(response.data);
                        setInfo(response.data);
                    } else {
                        dispatch(
                            SnackbarOpen({
                                text:
                                    response.error && response.error.message
                                        ? response.error.message
                                        : "Une erreur inattendu s'est produite.",
                                variant: "error",
                            }),
                        );
                        navigate(getRoutePathname('configuration_availability_list'));
                    }
                },
            );
        }
    }, [handlerForm, navigate, params.id]);

    React.useEffect(() => {
        const isActive = !!handlerForm.form.isActive?.value;
        handlerForm.setDisabled('startTime', !isActive);
        handlerForm.setDisabled('endTime', !isActive);
    }, [handlerForm, handlerForm.form.isActive?.value]);

    const save = () => {
        if (handlerForm.checkError() < 1) {
            handlerForm.setFormLoading(true);
            const data = handlerForm.getData();

            if (!data.isActive) {
                data.startTime = null;
                data.endTime = null;
            } else {
                if (!data.startTime || !data.endTime) {
                    if (!data.startTime) handlerForm.setError('startTime', 'Ce champ est obligatoire.');
                    if (!data.endTime) handlerForm.setError('endTime', 'Ce champ est obligatoire.');
                    handlerForm.setFormLoading(false);
                    return;
                }
            }

            ApiHandler.post(
                {
                    route: isEdit ? "configuration_availability_edit" : "configuration_availability_add",
                    params: isEdit ? { id: info.id } : "",
                    data: data,
                },
                (response) => {
                    if (response.status === 200 || response.status === 201) {
                        if (response.status === 201) {
                            navigate(getRoutePathname('configuration_availability', { id: response.data.id }));
                        }
                        dispatch(
                            SnackbarOpen({
                                text: isEdit ? "Disponibilité modifiée avec succès" : "Disponibilité créée avec succès",
                                variant: "success",
                            }),
                        );
                    } else if (response.status === 400) {
                        handlerForm.setErrorApi(response.error);
                    } else {
                        dispatch(
                            SnackbarOpen({
                                text:
                                    response.error && response.error.message
                                        ? response.error.message
                                        : "Une erreur inattendu s'est produite.",
                                variant: "error",
                            }),
                        );
                    }
                    handlerForm.setFormLoading(false);
                },
            );
        }
    };

    return (
        <ContentViewComponent loading={loading} breadcrumbs={breadcrumbs}>
            <Grid container spacing={1}>
                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    <SelectComponent id={"dayOfWeek"} options={optionsDayOfWeek} handler={handlerForm} />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}>
                    <TextFieldComponent id={"startTime"} handler={handlerForm} />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}>
                    <TextFieldComponent id={"endTime"} handler={handlerForm} />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <CheckboxComponent id={"isActive"} handler={handlerForm} />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <ButtonComponent style={{ width: '100%', marginTop: '20px' }} label={"Enregistrer"} onClick={save} />
                </Grid>
            </Grid>
        </ContentViewComponent>
    );
}

export default Availability;
